var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _linearGradient, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDocx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1881.25 1750"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M1801.056 0H517.694C473.404 0 437.5 35.904 437.5 80.194V437.5l743.75 218.75 700-218.75V80.194c0-44.29-35.904-80.194-80.194-80.194z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M1881.25 437.5H437.5V875l743.75 131.25 700-131.25V437.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M437.5 875v437.5l700 87.5 743.75-87.5V875H437.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M517.694 1750h1283.363c44.29 0 80.194-35.904 80.194-80.194V1312.5H437.5v357.306c0 44.29 35.904 80.194 80.194 80.194z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M969.806 350H437.5v1093.75h532.306c44.23-.144 80.05-35.964 80.194-80.194V430.194c-.144-44.23-35.964-80.05-80.194-80.194z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M926.056 393.75H437.5V1487.5h488.556c44.23-.144 80.05-35.964 80.194-80.194V473.944c-.144-44.23-35.964-80.05-80.194-80.194z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M926.056 393.75H437.5V1400h488.556c44.23-.144 80.05-35.964 80.194-80.194V473.944c-.144-44.23-35.964-80.05-80.194-80.194z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M882.306 393.75H437.5V1400h444.806c44.23-.144 80.05-35.964 80.194-80.194V473.944c-.144-44.23-35.964-80.05-80.194-80.194z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "file-docx_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 167.206,
    y1: 1420.912,
    x2: 795.294,
    y2: 333.088,
    gradientTransform: "matrix(1 0 0 -1 0 1752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2368c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1a5dbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146ac"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#file-docx_svg__a)",
    d: "M80.194 393.75h802.112c44.29 0 80.194 35.904 80.194 80.194v802.113c0 44.29-35.904 80.194-80.194 80.194H80.194c-44.29 0-80.194-35.904-80.194-80.194V473.944c0-44.29 35.904-80.194 80.194-80.194z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M329.088 1008.788c1.575 12.381 2.625 23.144 3.106 32.375h1.837c.7-8.75 2.158-19.294 4.375-31.631 2.217-12.338 4.215-22.765 5.994-31.281l84.35-363.913h109.069l87.5 358.444a530.822 530.822 0 0110.894 67.637h1.444a518.5 518.5 0 019.1-65.625l69.781-360.631h99.269l-122.588 521.5H577.238L494.113 790.3c-2.406-9.931-5.162-22.925-8.181-38.894-3.019-15.969-4.9-27.65-5.644-35h-1.444c-.962 8.487-2.844 21.088-5.644 37.8-2.8 16.713-5.046 29.079-6.738 37.1l-78.138 344.269h-117.95L147.131 614.337h101.062l75.994 364.656c1.707 7.482 3.326 17.457 4.901 29.795z"
  })));
}
export default SvgFileDocx;